import { NgModule } from '@angular/core';
import { ViewReferenceDialogComponent } from './view-reference-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from 'app/modules/shared/shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  declarations: [ViewReferenceDialogComponent],
  imports: [MatIconModule, MatProgressBarModule, SharedModule, PdfViewerModule],
  exports: [ViewReferenceDialogComponent]
})
export class ViewReferenceDialogModule { }
